import React, { useContext } from "react"
import MenuIcon from "@mui/icons-material/Menu"
import { AppBar, Box, IconButton, Toolbar } from "@mui/material"
import { Tag } from "antd"
import packageJson from "../../../../package.json"
import { useIsMobile } from "../../../hooks/useIsMobile.js"
import { SidebarContext } from "./sidebar/contexts/sidebar-context.js"

/**
 * Barra superior usada nos layouts novos, exibindo ambiente e menu mobile.
 * @returns {React.ReactElement}
 */
export function NewLayoutTopBar() {
  const isMobile = useIsMobile()
  const sidebarContext = useContext(SidebarContext)

  const envColor = packageJson?.ambiente === "Homologação" ? "orange" : "#000"
  const envLabel = `${packageJson?.ambiente || "Ambiente"}: ${packageJson?.version || "0.0.0"}`

  const handleDrawerOpen = () => {
    if (sidebarContext?.setSidebarOpen) {
      sidebarContext.setSidebarOpen(true)
    }
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#000000",
        color: "#fff",
        paddingRight: 2,
        zIndex: 10,
      }}
    >
      <Toolbar sx={{ minHeight: 64, gap: 1 }}>
        {isMobile && sidebarContext && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              mr: 1,
              ...(sidebarContext?.sidebarOpen && { visibility: "hidden" }),
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Box sx={{ flexGrow: 1 }} />

        <Tag color={envColor}>
          {envLabel}
        </Tag>
      </Toolbar>
    </AppBar>
  )
}
